import {
  RequestFiltersFieldset,
  RequestLangFieldset,
  RequestOrderingsFieldset,
  RequestRefFieldset,
} from "./components"
import { createRequest } from "./createRequest"

export const GetFirstRequest = createRequest({
  type: "getFirst",
  Fieldset() {
    return (
      <>
        <RequestLangFieldset />
        <RequestRefFieldset />
        <RequestFiltersFieldset />
        {/* Since `getFirst` is loose, orderings can still be used to sort which document is the first one */}
        <RequestOrderingsFieldset />
      </>
    )
  },
  getSnippetArgs(options) {
    return [
      {
        lang: options.lang,
        ref: options.ref,
        filters: options.filters,
        orderings: options.orderings,
      },
    ]
  },
  run(client, options) {
    return client.getFirst(options)
  },
})
